import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
} from 'react-intl';

import {
  Accordion,
  MultiColumnList,
  TextLink,
} from '@folio/stripes/components';

import {
  RECORD_LINKAGE,
  RECORD_LINK_FIELDS,
} from '../../../../constants';

const visibleColumns = [
  RECORD_LINK_FIELDS.NAME,
];
const columnMapping = {
  [RECORD_LINK_FIELDS.NAME]: <FormattedMessage id="ui-task-list.recordLinkage.field.name" />,
};
const resultsFormatter = {
  [RECORD_LINK_FIELDS.NAME]: (data) => (
    <TextLink
      href={data[RECORD_LINK_FIELDS.URL]}
      rel="noopener noreferrer"
      target="_blank"
    >
      {data[RECORD_LINK_FIELDS.NAME]}
    </TextLink>
  ),
};

const RecordLinkageView = ({
  recordLinkage,
}) => {
  return (
    <Accordion
      id={RECORD_LINKAGE}
      label={<FormattedMessage id="ui-task-list.title.accordion.recordLinkage" />}
    >
      <MultiColumnList
        columnMapping={columnMapping}
        contentData={recordLinkage}
        formatter={resultsFormatter}
        id={`${RECORD_LINKAGE}_list`}
        visibleColumns={visibleColumns}
      />
    </Accordion>
  );
};

RecordLinkageView.propTypes = {
  recordLinkage: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default RecordLinkageView;
